<template>
  <div class="upload">
    <!-- <el-dialog
      title="留归集团用户隐私保护政策"
      :visible.sync="vis"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <el-form ref="form" label-width="70px" width="1200px">
        <h1 class="fication">{{safekeeping}}</h1>
        <h1 class="fication">{{safekeepingEr}}</h1>
        <h1 class="fication">一、本政策使用范围</h1>
        <h2 class="jinggao">{{remind.yi}}</h2>
        <h2 class="jinggao">{{remind.er}}</h2>
        <h3 class="jinggao">{{remind.erYi}}</h3>
        <h3 class="jinggao">{{remind.erEr}}</h3>
        <h1 class="fication">二、信息收集</h1>
        <h2 class="jinggao">{{mation.yi}}</h2>
        <h2 class="jinggao">{{mation.er}}</h2>
        <h2 class="jinggao">{{mation.san}}</h2>
        <h2 class="jinggao">{{mation.si}}</h2>
        <h1 class="fication">三、信息储存</h1>
        <h2 class="jinggao">{{storeEr.yi}}</h2>
        <h2 class="jinggao">{{storeEr.er}}</h2>
        <h1 class="fication">四、信息使用</h1>
        <h2 class="jinggao">{{store.yi}}</h2>
        <h3 class="jinggao">{{store.yiYi}}</h3>
        <h3 class="jinggao">{{store.yiEr}}</h3>
        <h3 class="jinggao">{{store.yiSan}}</h3>
        <h3 class="jinggao">{{store.yiSi}}</h3>
        <h2 class="jinggao">{{store.er}}</h2>
        <h2 class="jinggao">{{store.san}}</h2>
        <h1 class="fication">五、信息披露</h1>
        <h2 class="jinggao">{{make.yi}}</h2>
        <h3 class="jinggao">{{make.yiYi}}</h3>
        <h3 class="jinggao">{{make.yiEr}}</h3>
        <h3 class="jinggao">{{make.yiSan}}</h3>
        <h3 class="jinggao">{{make.yiSi}}</h3>
        <h1 class="fication">六、Cookie的使用</h1>
        <h2 class="jinggao">{{Cookies.yi}}</h2>
        <h2 class="jinggao">{{Cookies.er}}</h2>
        <h2 class="jinggao">{{Cookies.san}}</h2>
        <h1 class="fication">七、信息保护</h1>
        <h2 class="jinggao">{{Information.yi}}</h2>
        <h2 class="jinggao">{{Information.er}}</h2>
        <h2 class="jinggao">{{Information.san}}</h2>
        <h1 class="fication">八、本政策更新</h1>
        <h2 class="jinggao">{{policy.yi}}</h2>
        <h2 class="jinggao">{{policy.er}}</h2>
        <h3 class="jinggao">{{policy.erYi}}</h3>
        <h3 class="jinggao">{{policy.erEr}}</h3>
        <h3 class="jinggao">{{policy.erSan}}</h3>
        <h3 class="jinggao">{{policy.erSi}}</h3>
        <h3 class="jinggao">{{policy.erWu}}</h3>
        <h3 class="jinggao">{{policy.erLiu}}</h3>
        <h1 class="fication">{{zuiyi}}</h1>
        <h1 class="fication">{{zuier}}</h1>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="subUpload" style="width: 134px;">已阅读</el-button>
      </div>
    </el-dialog>-->
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    isbool: {
      // 点击的用户隐私协议
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      //留归用户隐私协议
      xieyi: {
        safekeeping:
          "留归集团非常重视用户隐私和个人信息的保护。您（用户）在使用留归集团相应产品和服务时，我们可能会收集和使用您的相关信息。希望您仔细阅读并了解《留归集团用户隐私保护政策》（以下简称为“本政策”），清楚您在接受留归集团服务时，您的隐私信息是如何被收集、使用、储存、共享和转让的，以及留归集团为您提供的访问、更新、控制和保护这些信息的方式。",
        safekeepingEr:
          "再次提醒，请在使用留归集团任何服务前都仔细阅读并了解本政策。如果您愿意使用或继续使用留归集团提供的服务，则表示您同意按照本政策收集、储存、使用和分享、披露、保护您的个人信息。",
        remind: {
          fanwei: "一、本政策使用范围",
          yi:
            "1.当用户使用留归集团的任何服务时，本政策即适用。无论该服务是否单独设置了隐私条款，也无论用户是浏览用户（访客）还是正式用户（已注册登录）。",
          er: "2.请用户注意，本政策不适用于以下情况：",
          erYi:
            "（1）通过留归集团服务而接入的第三方服务（包括任何第三方网站）收集的信息；",
          erEr:
            "（2）通过在留归集团服务中进行广告服务的其他公司和机构所收集的信息。",
        },
        mation: {
          shouji: "二、信息收集",
          yi: "在用户注册留归集团帐号时，用户根据注册要求主动提供的个人信息；",
          er:
            "2.在用户使用留归集团网络服务，或访问留归集团平台网页时，留归集团会自动接收并记录用户浏览器、计算机或手机上的信息，包括但不限于用户的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及用户需求的网页记录等数据；",
          san: "3.留归集团通过合法途径从商业伙伴处取得的用户个人数据。",
          si:
            "4.留归集团严禁用户发布不良信息，如裸露、色情、亵渎内容、涉恐、涉暴等违法信息。当用户发布内容时，留归集团会进行审核，一经发现不良信息，会禁用该用户的所有权限，予以封号处理。",
        },
        storeEr: {
          chucun: "三、信息储存",
          yi:
            "1.存储地点：留归集团会依照法律法规的规定，将用户的个人信息存储于中华人民共和国境内（包含港澳台）。如需跨境存储，留归集团会单独征得用户的授权同意；",
          er:
            "2.存储期限：除相关法律法规的规定外，留归集团会在为用户提供服务目的所必需的期间内保留用户的个人信息，用户可要求留归集团立即删除或注销账户。对已匿名化的信息存储期限和处理，留归集团无需取得用户的授权同意，也无需再另行通知。",
        },
        store: {
          shiyong: "四、信息使用",
          yi:
            "1.为向用户提供优质服务，留归集团会分析用户信息，向用户提供感兴趣的内容，包括但不限于向用户发出产品或服务信息。具体用途如下：",
          yiYi: "（1）用于数据分析，精准用户画像；",
          yiEr:
            "（2）用于身份验证、客户服务、安全防范、诈骗监测、存档和备份等用途，确保用户信息的安全性；",
          yiSan: "（3）帮助留归集团设计新服务，改善现有服务；",
          yiSi:
            "（4）使留归集团更加了解用户是如何接入和使用网络服务的，从而有针对性地回应用户的个性化需求，如语言设定、位置设定、个性化的帮助服务和指示，或者其他方面的需求。",
          er:
            "2.留归集团不会向任何无关第三方提供、出售、出租、分享或交易用户个人信息。如果留归集团信息存储系统发生维修或升级，会事先发出推送消息来通知用户，请用户提前允许留归集团的消息通知。",
          san:
            "3.留归集团不允许任何第三方以任何手段收集、编辑、出售或者无偿传播用户的个人信息。任何留归集团用户如从事上述活动，一经发现，留归集团有权立即终止与该用户的服务协议，并予以封号处理。",
        },
        make: {
          pilou: "五、信息披露",
          yi:
            "1.未经用户同意，留归集团不会向第三方披露用户个人信息。但若发生如下情况，留归集团将依据用户意愿或法律规定部分或全部披露用户信息：",
          yiYi:
            "（1）为提供用户所要求的产品和服务而必须和第三方分享用户个人信息；",
          yiEr:
            "（2）根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；",
          yiSan:
            "（3）如用户出现违反中国有关法律法规，或者《留归集团用户使用协议》或相关规则的情况，需要向第三方披露；",
          yiSi:
            "（4）如用户是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。",
        },
        Cookies: {
          cookie: "六、Cookie的使用",
          yi:
            "1.为确保网站正常运转，留归集团会在用户的计算机或移动设备上存储名为“Cookie”的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储用户的偏好，为用户提供更加周到的个性化服务，包括推广服务等。",
          er:
            "2.用户有权选择接受或拒绝接受Cookie。用户可以通过修改浏览器设置的方式拒绝接受Cookie。但如果用户拒绝接受Cookie，则可能无法登录或使用依赖于Cookie的留归集团网络服务或功能。",
          san:
            "3.留归集团不会将Cookie取得的信息用于本政策所述目的之外的任何用途。且留归集团通过Cookie取得的信息，也适用于本政策。",
        },
        Information: {
          baohu: "七、信息保护",
          yi:
            "1.留归集团非常重视信息安全，会使用各种安全技术和程序，防止用户信息的丢失、不当使用、未经授权阅览或披露。",
          er:
            "2.请用户谅解，由于技术的限制以及风险防范的局限，即便留归集团尽全力加强安全措施，也无法保证信息百分之百的安全。因而，强烈建议用户自身也采取积极的措施，保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。",
          san:
            "3.如若不幸发生个人信息安全事件，留归集团将按照法律法规的要求，及时通知用户：安全事件的基本情况和可能的影响、留归集团已采取或将要采取的处置措施、用户可自主防范和降低风险的建议、对用户的补救措施等。留归集团会及时将事件相关情况以邮件、电话、推送等方式通知用户。在难以逐一告知个人信息主体时，留归集团会采取合理、有效的方式发布公告。",
        },
        policy: {
          gengxin: "八、本政策更新",
          yi:
            "1.如果留归集团决定更新隐私保护政策，那么会在本公司网站或者其他适当位置发布更新信息，以便用户了解新政策。",
          er: "2.本政策的重大更新包括但不限于：",
          erYi: "（1）留归集团的服务模式发生重大变化；",
          erEr: "（2）留归集团的所有权结构、组织架构等发生重大变化；",
          erSan: "（3）个人信息共享、转让或公开披露的主要对象发生变化；",
          erSi: "（4）用户参与个人信息处理方面的权利及其行使方式发生重大变化；",
          erWu:
            "（5）留归集团负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；",
          erLiu: "（6）个人信息安全影响评估报告表明存在高风险时。",
          san: "3.留归集团保留随时修改本政策的权利，一切解释权归留归集团所有。",
        },
        zuiyi:
          "最后，请用户在使用留归集团网络服务时，谨慎对任何第三方披露自己的个人信息，如联络方式、邮政地址等。如用户发现自己的个人信息泄露，尤其是留归集团的账号密码发生泄露，请立即联络留归集团的客服人员，以便采取相应的保护措施。",
        zuier:
          "感谢您花时间了解留归集团的隐私保护政策！我们将尽全力保护您的个人信息和合法权益，再次感谢您的信任！",
      },
      TempName: "",
      vis: false,
      show: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    closeDialog() {
      this.$emit("close-dialogStatus", true);
    },
    subUpload() {
      this.vis = false;
    },
  },
  watch: {
    isbool(newValue, oldValue) {
      // console.log("22", this.show);
      // console.log(this.xieyi);
      this.show = newValue;
      let arr = [
        this.xieyi.safekeeping,
        this.xieyi.safekeepingEr,
        this.xieyi.remind.fanwei,
        this.xieyi.remind.yi,
        this.xieyi.remind.er,
        this.xieyi.remind.erYi,
        this.xieyi.remind.erEr,
        this.xieyi.mation.shouji,
        this.xieyi.mation.yi,
        this.xieyi.mation.er,
        this.xieyi.mation.san,
        this.xieyi.mation.si,
        this.xieyi.storeEr.chucun,
        this.xieyi.storeEr.yi,
        this.xieyi.storeEr.er,
        this.xieyi.store.shiyong,
        this.xieyi.store.yi,
        this.xieyi.store.yiYi,
        this.xieyi.store.yiEr,
        this.xieyi.store.yiSan,
        this.xieyi.store.yiSi,
        this.xieyi.store.er,
        this.xieyi.store.san,
        this.xieyi.make.pilou,
        this.xieyi.make.yi,
        this.xieyi.make.yiYi,
        this.xieyi.make.yiEr,
        this.xieyi.make.yiSan,
        this.xieyi.make.yiSi,
        this.xieyi.Cookies.cookie,
        this.xieyi.Cookies.yi,
        this.xieyi.Cookies.er,
        this.xieyi.Cookies.san,
        this.xieyi.Information.baohu,
        this.xieyi.Information.yi,
        this.xieyi.Information.er,
        this.xieyi.Information.san,
        this.xieyi.policy.gengxin,
        this.xieyi.policy.yi,
        this.xieyi.policy.er,
        this.xieyi.policy.erYi,
        this.xieyi.policy.erEr,
        this.xieyi.policy.erSan,
        this.xieyi.policy.erSi,
        this.xieyi.policy.erWu,
        this.xieyi.policy.erLiu,
        this.xieyi.policy.san,
        this.xieyi.zuiyi,
        this.xieyi.zuier,
      ];
      let str = arr.join(" <br/> ");
      if (newValue === true) {
        this.$dialog
          .alert({
            confirmButtonText: "已阅读",
            title: "留归集团用户隐私保护政策",
            dangerouslyUseHTMLString: true,
            // message:'哈哈哈哈，嗯嗯，Just do it',
            message: str,
            confirmButtonColor: "red",
          })
          .then(() => {
            // console.log("点击了确认");
            this.$emit("isShowEr", false);
          })
          .catch(() => {
            // console.log("点击了取消");
            this.$emit("isShowEr", false);
          });
      }
    },
  },
};
</script>
<style lang='scss' scope>
.upload {
  .upbtn {
    text-align: right;
    // .btn {
    //     color: #fff;
    //     background-color: #409eff;
    //     border-color: #409eff;
    // }
  }
  .el-dialog__header {
    padding-left: 27px;
    .el-dialog__title {
      font-size: 12px;
    }
  }
  .el-dialog__body {
    padding: 30px 20px 0 20px;
    color: #606266;
    font-size: 12px;
    word-break: break-all;
    .el-form-item__label {
      font-size: 12px;
    }
    .el-form-item__content {
      line-height: 30px;
      position: relative;
      font-size: 12px;
    }
  }
  .el-dialog__footer {
    text-align: center;
  }
  .el-upload--text {
    width: initial;
    height: initial;
    border: none;
  }
  .fication {
    text-align: left;
    margin-bottom: 10px;
  }
  .jinggao {
    text-align: left;
    // color: red;
    margin-left: 5px;
   
    font-size: 14px;
    color: rgba(149, 149, 149, 1);
    margin-bottom: 10px;
  }
  /deep/.dialog-footer {
    color: red;
  }
  /deep/.el-dialog {
    // padding: 20px;
    // border-radius: 20px;
    // height: 70%;
    // width: 1200px;
    width: 100%;
    // height: 780px;
    overflow: auto;
    .el-form {
      box-sizing: border-box;
      // width: 1200px;
      height: 540px;
      overflow: auto;
    }
  }
}
</style>